import React, { useState, useEffect, useCallback } from "react";
import Spinner from "./BePatient";
import LoggedNav from "../components/LoggedNav";
import { useNavigate } from "react-router-dom";
import ContactUsPop from "../components/ContactUsPop";
import OrderItemCustomer from "../components/OrderItemCustomer";
import Pagination from "../components/Pagination";

const LIMIT = 12;

function OrderListCustomer(props) {
  const [data, setCustomer] = useState([]);
  const [loading, setLoading] = useState(true);
  const [listLoading, setListLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [search] = useState("");
  const navigate = useNavigate();  

  const fetchOrders = useCallback(async (page, searchQuery) => {
    const isInitial = page === 1 && !searchQuery;
    isInitial ? setLoading(true) : setListLoading(true);

    try {
      const offset = (page - 1) * LIMIT;
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}book/customer_booking_history`,
        {
          method: "POST",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            user_id: parseInt(localStorage.getItem("logged_user_id")),
            offset,
            limit: LIMIT,
            search: searchQuery || "",
            filters: {
              project_id: [],
              location: [],
              configuration: [],
              budget_from: [],
              budget_to: [],
            },
          }),
        }
      );

      const parsedData = await response.json();
      console.log(parsedData);
      setCustomer(parsedData.data || []);
      setTotalItems(parsedData.total ?? parsedData.count ?? parsedData.data?.length ?? 0);
    } catch (error) {
      console.error("Error fetching orders:", error);
    } finally {
      setLoading(false);
      setListLoading(false);
    }
  }, []);

  const getStatusList = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_BASE_URL}status/all_status`);
      const parsedData = await res.json();
      for (let index = 0; index < parsedData.data.length; index++) {
        const element = parsedData.data[index];
        localStorage.setItem(element.name, element.color);
      }
    } catch (error) {
      console.error("Error fetching status list:", error);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: "smooth" });
    fetchOrders(page, search);
  };

  const role = localStorage.getItem("role");
  const token = localStorage.getItem("token");

  useEffect(() => {
    const title = `Order History | CHEF REPUBLIC`;
    const desc = "";
    const titleTag = document.querySelector("title");
    titleTag.innerText = title;
    document.querySelector("meta[name='title']").setAttribute("content", title);
    document.querySelector("meta[name='description']").setAttribute("content", desc);
    document.querySelector("meta[property='og:title']").setAttribute("content", title);
    document.querySelector("meta[property='og:description']").setAttribute("content", desc);
    document.querySelector("meta[property='twitter:title']").setAttribute("content", title);
    document.querySelector("meta[property='twitter:description']").setAttribute("content", desc);

    if (role === null || role !== "1") {
      navigate("/sign-in");
      window.location.reload();
    }
    if (token === null || !token) {
      navigate("/sign-in");
      window.location.reload();
    }

    getStatusList();
    fetchOrders(1, "");
    // eslint-disable-next-line
  }, []);

  return (
    <>
      {loading ? (
        <Spinner />
      ) : (
        <>
          <LoggedNav customer={props.customer} />
          <div className="container my-5">
            <h1 className="fw-bold text-center">Order History</h1>

            {/* Order list */}
            <div
              className="row py-4"
              style={{ opacity: listLoading ? 0.5 : 1, transition: "opacity 0.2s" }}
            >
              {listLoading && (
                <div className="text-center w-100 mb-3">
                  <div className="spinner-border spinner-border-sm text-secondary" role="status" />
                </div>
              )}
              {data && data.length > 0 ? (
                data.map((content, index) => (
                  <OrderItemCustomer key={index} data={content} />
                ))
              ) : (
                <h4 className="py-3 text-center fs-6">You have No Orders yet</h4>
              )}
            </div>

            {/* Pagination */}
            <Pagination
              currentPage={currentPage}
              totalItems={totalItems}
              itemsPerPage={LIMIT}
              onPageChange={handlePageChange}
              loading={listLoading}
            />
          </div>
          <ContactUsPop />
        </>
      )}
    </>
  );
}

export default OrderListCustomer;
